import { Letter, MapPoint, Phone } from '@solar-icons/react';
import React from 'react';

type Props = {
  type: 'email' | 'phone' | 'address';
  value: string;
  label?: string;
  className?: string;
  mapUrl?: string;
};

const ContactItem = ({ type, value, label, className = '', mapUrl }: Props) => {
  const Icon = type === 'email' ? Letter : type === 'phone' ? Phone : MapPoint;

  const content =
    type === 'address' ? (
      <address className="mb-0 contact-value">
        {mapUrl ? (
          <a href={mapUrl} target="_blank" rel="noreferrer" className="text-reset text-decoration-none contact-value">
            {value}
          </a>
        ) : (
          value
        )}
      </address>
    ) : (
      <a
        href={type === 'email' ? `mailto:${value}` : `tel:${value.replace(/\s/g, '')}`}
        className="text-reset text-decoration-none contact-value"
      >
        {value}
      </a>
    );

  return (
    <div className={`d-flex gap-3 ${className}`}>
      <Icon weight="Bold" size={32} color="#f96d3b" className="flex-shrink-0" />
      <div className="d-grid gap-1 align-self-center">
        <div className="fw-medium">{content}</div>
        {label && <small className="text-muted">{label}</small>}
      </div>
    </div>
  );
};

export default ContactItem;
